import { connect } from 'react-redux';
import { showAddModal } from 'redux/modules/address/actions';
import AddAddressButton from 'components/Address/common/AddAddressButton/AddAddressButton';

export default connect((state, props) => ({ ...props }), { onClick: () => showAddModal() })(
  AddAddressButton,
);
